<template>
  <div v-loading="detailsloading" style="width:800px;margin-left:20px;">
    <div style="
height:auto;line-height: 25px;border-bottom:1px solid #606266;">
      <el-row>
        <el-col :span="2">
          <i class="el-icon-user" style="font-size:25px;"></i>
        </el-col>
        <el-col :span="3">{{ showDetails.name }}</el-col>
        <el-col :span="5">{{ showDetails.phone }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <i class="el-icon-warning-outline" style="font-size:25px;"></i>
        </el-col>
        <el-col :span="3">有效期至：</el-col>
        <el-col :span="5">{{ showDetails.expired }}</el-col>
      </el-row>

      <el-row>
        <el-col :span="2">
          <i class="el-icon-warning-outline" style="font-size:25px;"></i>
        </el-col>
        <el-col :span="3">备注：</el-col>
        <el-col :span="5">{{ showDetails.remark }}</el-col>
      </el-row>

      <el-row>
        <el-col :span="2">
          <i class="el-icon-warning-outline" style="font-size:25px;"></i>
        </el-col>
        <el-col :span="12">订单预订成功后不可退改，敬请谅解</el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <template>
            <img :src="showDetails.product_snap.cover" class="user-avatar" />
          </template>
        </el-col>
        <el-col :span="13">{{ showDetails.product_snap.title }}</el-col>
      </el-row>
    </div>
    <div
      style="height:auto;line-height: 25px;border-bottom:1px solid #606266;"
      v-if="showDetails.product_snap.type==1"
    >
      <div
        v-for="(order_package_item,
      order_package_index) in showDetails.order_package"
        :key="order_package_index"
      >
        <el-row>
          <el-col :span="4">{{ order_package_item[0].title }}</el-col>
          <span style="text-align:right;" v-if="!order_package_index">
            <el-col :span="18" style="color:red;" v-if="showDetails.product_snap.currency_type == 2">A${{ showDetails.product_snap.price }}</el-col>
            <el-col :span="18" style="color:red;" v-else>￥{{ showDetails.product_snap.price }}</el-col>
            <el-col :span="1">x{{ order_package_item.length }}</el-col>
          </span>
        </el-row>
        <el-collapse accordion v-if="!order_package_index">
          <el-collapse-item :title="showDetails.product_snap.package_name" name="1">
            <div style="background:#909399;height:auto;line-height: 40px;">
              <p
                style="margin-left: 30px;"
                v-html="showDetails.product_snap.description"
              >{{ showDetails.product_snap.description }}</p>

              <i class="el-icon-location" style="font-size:20px;margin-left: 30px;"></i>
              <p style="margin-left: 5px;display:inline">{{ order_package_item[0].shop.name }}</p>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-row style="height:10px;line-height:40px" v-if="!order_package_index">
          <el-col :span="8" :offset="8">预约时间</el-col>
          <el-col :span="6">处理时间</el-col>
        </el-row>
        <el-row style="height:10px;line-height:40px" v-else>
          <el-col :span="6" :offset="16">处理时间</el-col>
        </el-row>
        <el-divider></el-divider>
        <div v-for="(item, index) in order_package_item" :key="index">
          <span>
            <el-row v-if="!order_package_index">
              <el-col :span="3">第{{ index + 1 }}张：</el-col>
              <el-col :span="4">
                <span v-if="item.status == 0">待预约</span>
                <span v-else-if="item.status == 1">待确认</span>
                <span v-else-if="item.status == 2">预约成功</span>
                <span v-else-if="item.status == 3">预约失败</span>
              </el-col>
              <el-col
                v-if="item.date"
                :span="item.status == 1 &&
                    (index &&
                    item.is_handled  ||
                    !index)?14:8"
              >{{ item.date }}至{{item.endDate}}</el-col>
              <el-col :span="6" v-if="(item.status == 2||item.status == 3)  ">{{ item.updated_at }}</el-col>
              <el-col :span="3">
                <el-button
                  v-if="item.status == 1 && (index && item.is_handled || !index) && showDetails.order_status != 8 && showDetails.pay_status != 3"
                  @click="handle(item)"
                >处理</el-button>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="3">第{{ index + 1 }}张：</el-col>
              <el-col :span="item.status == 0?18:12">
                <span v-if="item.status == 0">待使用</span>
                <span v-else>已使用</span>
              </el-col>
              <el-col :span="6" v-if="item.status != 0">{{ item.updated_at }}</el-col>
              <el-col :span="3" v-if="item.status == 0 && showDetails.order_status != 8 && showDetails.pay_status != 3">
                <el-button @click="usePackage(item.id)">使用</el-button>
              </el-col>
            </el-row>
          </span>
          <el-divider></el-divider>
        </div>
      </div>
    </div>
    <div style="height:auto;line-height: 25px;border-bottom:1px solid #606266;" v-else>
      <div v-for="(oritem, orindex) in showDetails.order_route" :key="orindex">
        <el-row v-if="!orindex">
          <el-col :span="4">{{ }}</el-col>
          <span style="text-align:right;">
            <el-col :span="15" style="color:red;" v-if="showDetails.product_snap.currency_type == 2">A${{ showDetails.product_snap.price }}</el-col>
            <el-col :span="15" style="color:red;" v-else>￥{{ showDetails.product_snap.price }}</el-col>
            <el-col :span="3">x{{ showDetails.order_route.length }}</el-col>
            <el-col :span="1">
              <i class="el-icon-arrow-right"></i>
            </el-col>
          </span>
        </el-row>
        <span v-if="!orindex">
          <el-row style="height:10px;line-height:40px">
            <el-col :span="6" :offset="16">处理时间</el-col>
          </el-row>
          <el-divider></el-divider>
        </span>
        <span>
          <el-row>
            <el-col :span="3">第{{ orindex + 1 }}张：</el-col>
            <el-col :span="!oritem.status?18:12">
              <span v-if="!oritem.status">待使用</span>
              <span v-else>已使用</span>
            </el-col>
            <el-col :span="6" v-if="oritem.status">{{ oritem.updated_at }}</el-col>
            <el-col :span="3" v-if="!oritem.status && showDetails.order_status != 8 && showDetails.pay_status != 3">
              <el-button @click="useOrderRoute(oritem.id,  showDetails.order_no)">使用</el-button>
            </el-col>
          </el-row>
        </span>
        <el-divider></el-divider>
      </div>
    </div>
    <div style="position: relative;line-height: 25px;border-bottom:1px solid #606266;height:auto;">
      <div v-for="(ritem, rindex) in showDetails.order_recommend" :key="rindex">
        <el-row>
          <el-col :span="4">{{ ritem[0].title }}</el-col>
          <span style="text-align:right;">
            <el-col :span="15" style="color:red;" v-if="showDetails.product_snap.currency_type == 2">A${{ ritem[0].price }}</el-col>
            <el-col :span="15" style="color:red;" v-else>￥{{ ritem[0].price }}</el-col>
            <el-col :span="3">x{{ ritem.length }}</el-col>
            <el-col :span="1">
              <i class="el-icon-arrow-right"></i>
            </el-col>
          </span>
        </el-row>
        <el-row style="height:10px;line-height:40px">
          <el-col :span="6" :offset="16">处理时间</el-col>
        </el-row>
        <el-divider></el-divider>
        <div style="line-height: 50px;" v-for="(pritem, prindex) in ritem" :key="prindex">
          <span>
            <el-row>
              <el-col :span="3">第{{ prindex + 1 }}张：</el-col>
              <el-col :span="!pritem.status?18:12">
                <span v-if="!pritem.status">待使用</span>
                <span v-else>已使用</span>
              </el-col>
              <el-col :span="6" v-if="pritem.status">{{ pritem.updated_at }}</el-col>
              <el-col :span="3" v-if="!pritem.status && showDetails.order_status != 8 && showDetails.pay_status != 3">
                <el-button @click="use(pritem.id,showDetails.order_no)">使用</el-button>
              </el-col>
            </el-row>
          </span>
          <el-divider></el-divider>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px;">
      <el-row>
        <el-col :span="14">订单号</el-col>
        <span style="text-align:right;">
          <el-col :span="8">{{ showDetails.order_no }}</el-col>
        </span>
        <el-divider></el-divider>
      </el-row>

      <el-row>
        <el-col :span="18">商品金额</el-col>
        <span style="text-align:right;">
          <el-col :span="4">￥{{ showDetails.pay_price }}</el-col>
        </span>
        <el-divider></el-divider>
      </el-row>
      <el-row>
        <el-col :span="15">下单时间</el-col>
        <span style="text-align:right;">
          <el-col :span="7">{{ showDetails.pay_datetime }}</el-col>
        </span>
        <el-divider></el-divider>
      </el-row>
      <el-row>
        <el-col :span="19">优惠券</el-col>
        <span style="text-align:right;">
          <el-col :span="3">￥{{ showDetails.discount_price }}</el-col>
          <el-col :span="1">
            <i class="el-icon-arrow-right"></i>
          </el-col>
        </span>
        <el-divider></el-divider>
      </el-row>
      <el-row>
        <el-col :span="18">合计</el-col>
        <span style="text-align:right;">
          <el-col :span="4">￥{{ showDetails.total_price }}</el-col>
        </span>
        <el-divider></el-divider>
      </el-row>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="this.goBack">返回</el-button>
    </div>

    <el-dialog title="预约通过" :visible.sync="appointmentVisible" width="400px">
      <el-tag>预约张数:{{num}}</el-tag>
      <el-tag type="warning" style="margin-left:20px;">需要住几晚:{{live_time}}</el-tag>
      <div style="margin:20px 0;">
        <span>入住时间：</span>
        <el-date-picker
          v-model="date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择预约时间"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <div style="margin:0 0 20px;">
        <span>退房时间：{{endDate}}</span>
      </div>
      <el-button size="small" @click="refuseAppointment">驳回</el-button>
      <el-button size="small" type="primary" @click="passAppointment">通过</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import request from "@/utils/request";
import { guid, base64toFile } from "@/utils/index";
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import * as qiniu from "qiniu-js";
import AMapPosition from "@/components/AMapPosition";
var moment = require("moment");
export default {
  components: {
    "img-crop-upload": imgCropUpload,
    "amap-position": AMapPosition,
    uploadList
  },
  data() {
    return {
      detailsloading: false,
      array: [],
      temp: [],
      list: null,
      total: null,
      listLoading: true,
      refuseInfo: {
        refuse_reason: "",
        order_no: ""
      },
      showDetails: { product_snap: { product_package: [{}] } },
      info: {
        product_snap: { product_package: [{}] },
        order_return: {}
      },
      id: null,
      order_no: null,
      date: null,
      endDate: null,
      live_time: "",
      num: "",
      expired: "",
      listQuery: {
        page: 1,
        limit: 10,
        shop_name: "",
        order_no: "",
        title: "",
        name: "",
        phone: "",
        type: "",
        order_status: ""
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      reasonVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      dialogPvVisible: false,
      appointmentVisible: false,
      pvData: [],
      form: {
        id: "",
        img: "",
        imgArray: [],
        link_type: 0,
        link: "",
        weight: 0,
        description: ""
      },
      rules: {
        img: [{ required: true, message: "图片不能为空", trigger: "blur" }]
      },
      btnLoading: false,

      show: false,
      imgBase64Data: "" // the datebase64 url of created image
    };
  },
  created() {
    this.getDetails();
  },
  computed: {
    pickerOptions() {
      let _this = this;
      let expired = moment(_this.expired).format("x");
      let today = moment()
        .subtract(1, "days")
        .format("x");
      return {
        disabledDate(time) {
          return time.getTime() > expired || time.getTime() < today;
        }
      };
    }
  },
  watch: {
    date(newVal) {
      this.endDate = moment(newVal)
        .add(this.live_time, "days")
        .format("YYYY-MM-DD");
    }
  },
  methods: {
    getDetails() {
      this.listLoading = true;
      request({
        url: "/api/backend/order/detail",
        method: "get",
        params: { order_no: this.$route.query.order_no }
      }).then(response => {
        this.showDetails = response.data;
        if (this.showDetails.order_package) {
          this.temp = this.showDetails.order_package;
          this.showDetails.order_package = [];
          this.temp.forEach(item => {
            if (
              !this.showDetails.order_package.length ||
              this.showDetails.order_package[
                this.showDetails.order_package.length - 1
              ][0].product_package_id != item.product_package_id
            ) {
              this.showDetails.order_package.push([item]);
            } else if (
              this.showDetails.order_package[
                this.showDetails.order_package.length - 1
              ][0].product_package_id == item.product_package_id
            ) {
              this.showDetails.order_package[
                this.showDetails.order_package.length - 1
              ].push(item);
            }
          });

          // this.showDetails.order_package.forEach((item, index) => {
          this.array = [];
          this.showDetails.order_package[0].forEach((item, index) => {
            this.showDetails.order_package[0][index]["endDate"] = moment(
              item.date
            )
              .add(
                this.showDetails.order_package
                  ? this.showDetails.order_package[0][0].live_time
                  : "",
                "days"
              )
              .format("YYYY-MM-DD");
            if (item.status == 1) {
              if (this.isInArray(this.array, item.order_appointment_id)) {
                this.showDetails.order_package[0][index]["is_handled"] = 0;
              } else {
                this.showDetails.order_package[0][index]["is_handled"] = 1;
                this.array.push(item.order_appointment_id);
              }
            }
          });
        }
        // });
        this.temp = this.showDetails.order_recommend;
        this.showDetails.order_recommend = [];
        this.temp.forEach(item => {
          if (
            !this.showDetails.order_recommend.length ||
            this.showDetails.order_recommend[
              this.showDetails.order_recommend.length - 1
            ][0].product_recommend_id != item.product_recommend_id
          ) {
            this.showDetails.order_recommend.push([item]);
          } else if (
            this.showDetails.order_recommend[
              this.showDetails.order_recommend.length - 1
            ][0].product_recommend_id == item.product_recommend_id
          ) {
            this.showDetails.order_recommend[
              this.showDetails.order_recommend.length - 1
            ].push(item);
          }
        });
        this.listLoading = false;
      });
    },
    isInArray(arr, value) {
      for (var i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },

    goBack() {
      this.$store.dispatch("tagsView/delView", this.$route);
      this.$router.go(-1);
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handle(item) {
      this.date = item.date;
      this.num = this.showDetails.num;
      this.order_no = item.order_no;
      this.expired = this.showDetails.expired;
      this.live_time = this.showDetails.order_package
        ? this.showDetails.order_package[0][0].live_time
        : "";
      this.id = item.order_appointment_id;
      this.endDate = moment(this.date)
        .add(this.live_time, "days")
        .format("YYYY-MM-DD");
      this.appointmentVisible = true;
    },
    handleChange(id) {
      request({
        url: "/api/backend/orderStatusChange",
        method: "get",
        params: { id: id }
      }).then(response => {
        this.getList();
      });
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    use(id, order_no) {
      this.detailsloading = true;
      this.$confirm("确定要使用, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/order/use",
            method: "get",
            params: { id: id }
          }).then(response => {
            this.btnLoading = false;
            this.$notify({
              title: "成功",
              message: "使用成功",
              type: "success",
              duration: 2000
            });

            this.getDetails(order_no);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        })
        .finally(() => {
          this.detailsloading = false;
        });
    },
    useOrderRoute(id, order_no) {
      this.detailsloading = true;
      this.$confirm("确定要使用, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/order/useOrderRoute",
            method: "get",
            params: { id: id }
          }).then(response => {
            this.btnLoading = false;
            this.$notify({
              title: "成功",
              message: "使用成功",
              type: "success",
              duration: 2000
            });

            this.getDetails(order_no);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        })
        .finally(() => {
          this.detailsloading = false;
        });
    },
    resetForm() {
      this.form = {
        id: "",
        img: "",
        imgArray: [],
        link_type: 0,
        link: "",
        weight: 0,
        description: ""
      };
      this.btnLoading = false;
    },

    // handleCreate(order_no) {
    //   request({
    //     url: "/api/backend/order/detail",
    //     method: "get",
    //     params: { order_no: order_no }
    //   }).then(response => {
    //     this.showDetails = response.data;
    //     this.temp = this.showDetails.order_package;
    //     this.showDetails.order_package = [];
    //     this.temp.forEach(item => {
    //       if (
    //         !this.showDetails.order_package.length ||
    //         this.showDetails.order_package[
    //           this.showDetails.order_package.length - 1
    //         ][0].product_package_id != item.product_package_id
    //       ) {
    //         this.showDetails.order_package.push([item]);
    //       } else if (
    //         this.showDetails.order_package[
    //           this.showDetails.order_package.length - 1
    //         ][0].product_package_id == item.product_package_id
    //       ) {
    //         this.showDetails.order_package[
    //           this.showDetails.order_package.length - 1
    //         ].push(item);
    //       }
    //     });
    //     this.temp = this.showDetails.order_recommend;
    //     this.showDetails.order_recommend = [];
    //     this.temp.forEach(item => {
    //       if (
    //         !this.showDetails.order_recommend.length ||
    //         this.showDetails.order_recommend[
    //           this.showDetails.order_recommend.length - 1
    //         ][0].product_recommend_id != item.product_recommend_id
    //       ) {
    //         this.showDetails.order_recommend.push([item]);
    //       } else if (
    //         this.showDetails.order_recommend[
    //           this.showDetails.order_recommend.length - 1
    //         ][0].product_recommend_id == item.product_recommend_id
    //       ) {
    //         this.showDetails.order_recommend[
    //           this.showDetails.order_recommend.length - 1
    //         ].push(item);
    //       }
    //     });
    //     console.log(this.showDetails);
    //   });
    // },
    handleReason(order_no) {
      this.refuseInfo = {
        refuse_reason: "",
        order_no: ""
      };
      this.refuseInfo.order_no = order_no;
      this.reasonVisible = true;
    },
    refuse() {
      request({
        url: "/api/backend/orderReturn/cancel",
        method: "post",
        data: this.refuseInfo
      }).then(response => {
        this.reasonVisible = false;
        this.dialogFormVisible1 = false;
        this.getList();
      });
    },

    afterSales(order_no) {
      request({
        url: "/api/backend/orderReturn",
        method: "get",
        params: { order_no: order_no }
      }).then(response => {
        this.info = response.data;
        this.temp = this.info.order_recommend;
        this.info.order_recommend = [];
        this.temp.forEach(item => {
          if (
            !this.info.order_recommend.length ||
            this.info.order_recommend[this.info.order_recommend.length - 1][0]
              .product_recommend_id != item.product_recommend_id
          ) {
            this.info.order_recommend.push([item]);
          } else if (
            this.info.order_recommend[this.info.order_recommend.length - 1][0]
              .product_recommend_id == item.product_recommend_id
          ) {
            this.info.order_recommend[
              this.info.order_recommend.length - 1
            ].push(item);
          }
        });
        console.log(this.info);
        this.dialogFormVisible1 = true;
      });
    },
    // pass(order_no) {
    //   request({
    //     url: "/api/backend/order/refund",
    //     method: "post",
    //     data: { order_no: order_no }
    //   }).then(response => {
    //     this.getList();
    //   });
    // },
    refuseAppointment() {
      request({
        url: "/api/backend/order/refuse",
        method: "post",
        data: { id: this.id }
      }).then(response => {
        this.$message({
          type: "success",
          message: "驳回成功!"
        });
        this.getDetails(this.order_no);
        this.appointmentVisible = false;
      });
    },
    passAppointment() {
      request({
        url: "/api/backend/order/agree",
        method: "post",
        data: { id: this.id, date: this.date }
      }).then(response => {
        this.$message({
          type: "success",
          message: "处理成功!"
        });
        this.getDetails();
        this.appointmentVisible = false;
      });
    },
    usePackage(id) {
      this.btnLoading = true;
      this.detailsloading = true;
      this.$confirm("确定要使用, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/order/usePackage",
            method: "post",
            data: { id: id }
          }).then(response => {
            this.$message({
              type: "success",
              message: "使用成功!"
            });

            this.getDetails();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        })
        .finally(() => {
          this.btnLoading = false;
          this.detailsloading = false;
        });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign(
        {
          imgArray: [
            "http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png",
            "http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png"
          ]
        },
        row
      ); // copy obj
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handledown(row) {
      this.resetForm();
      this.form = Object.assign(
        {
          imgArray: [
            "http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png",
            "http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png"
          ]
        },
        row
      ); // copy obj
      this.dialogStatus = "update";
      this.dialogFormVisible1 = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      console.log(this.form, this.form.imgArray);
      return;
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/banner/save",
            method: "post",
            data: this.form
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/banner/del",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgBase64Data, field) {
      console.log("-------- 裁剪成功 --------");
      let that = this;
      this.imgBase64Data = imgBase64Data;
      getQiniuToken().then(response => {
        let file = base64toFile(imgBase64Data, "tmp.png");
        let key = guid() + ".png";
        let token = response.data.token;
        let baseUrl = response.data.baseUrl;
        let putExtra = {};
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z2
        };
        var observable = qiniu.upload(file, key, token, putExtra, config);
        var subscription = observable.subscribe({
          next(res) {
            // ...
          },
          error(err) {
            // ...
          },
          complete(res) {
            // ...
            let imgUrl = baseUrl + "/" + key;
            that.form.img = imgUrl;
            console.log(imgUrl);
          }
        }); // 上传开始
        // or
        // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
        // subscription.unsubscribe() // 上传取消
      });
    }
  }
};
</script>

<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.uploaded-img {
  width: 120px;
  height: 120px;
}
.upload-block:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
